import React, {useState} from 'react'
import Modal from 'react-bootstrap/Modal'
import { Chip, Button, Select, MenuItem } from '@mui/material';
import { AlarmData } from '../Alarm Functions/AlarmOverviewFunctions'
import AlarmTypeImage from '../../assets/Alarm Help Images/alarmType.png'
import AlarmChannelImage from '../../assets/Alarm Help Images/AlarmChannel.png'
import AlarmSetInput from '../../assets/Alarm Help Images/AlarmSetInput.png'
import AlarmClrInput from '../../assets/Alarm Help Images/alarmClearInput.png'
import AlarmConsumptionSet from '../../assets/Alarm Help Images/AlarmConsumptionSet1.png'
import AlarmConsumptionDate from '../../assets/Alarm Help Images/SetDateRangeConsumption.png'
import AlarmCount from '../../assets/Alarm Help Images/AlarmCount.png'
import AlarmMessage from '../../assets/Alarm Help Images/Alarm Message.png'
import AlarmTimeframe from '../../assets/Alarm Help Images/AlarmTimeRange.png'
import AlarmDateRange from '../../assets/Alarm Help Images/AlarmDateRange.png'
import { FormattedMessage } from 'react-intl';



interface Props {
    show: boolean
    toggleHelpModal: () => void
    tempAlarm: AlarmData
    currentPage: number
}

const AlarmHelpModal: React.FC<Props> = ({ show, toggleHelpModal, tempAlarm, currentPage }) => {


    const overlayBoxStyle = {
        backgroundColor: "#f7f7f7",
        borderRadius: "5px",
        padding: "10px 10px 1px 10px",
        boxShadow: "2px 2px 10px #00000060",
        borderLeft: '6px solid #00bf00',
        zIndex: 1000000000000,
        width: '90%'
    }

    return (
        <Modal
            show={show}
            style={{
                zIndex: 10000000000,
                transform: 'translateX(2.5vw)',
                marginTop: 20
            }}
            className='modal-95w'
        >
            <Modal.Header>
                <Modal.Title><FormattedMessage id="Help Guide" /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(AlarmTypeImage ||
                    AlarmChannelImage ||
                    AlarmSetInput ||
                    AlarmClrInput ||
                    AlarmConsumptionSet ||
                    AlarmConsumptionDate ||
                    AlarmCount ||
                    AlarmMessage ||
                    AlarmTimeframe ||
                    AlarmDateRange
                ) && <div>
                    {currentPage === 1 &&
                        <div style={{ display: 'flex', width: '100%' }}>
                            <div style={{ width: '50%', margin: '0 10px' }}>
                                <h4><b><FormattedMessage id="Step 1" /></b></h4>
                                <div style={{ width: '100%', position: 'relative' }}>
                                    <img src={AlarmTypeImage} width="100%" />
                                    <div style={{ position: 'absolute', top: '60%', left: '45%', zIndex: 10000 }}>
                                        <div style={{ ...overlayBoxStyle }}>
                                            <p><FormattedMessage id="From here you can select the alarm type you want to set, differrent alarm type are available on different loggers based on their conifg and model type." /></p>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div style={{ width: '50%', margin: '0 10px' }}>
                                <h4><b><FormattedMessage id="Step 2" /></b></h4>
                                <div style={{ width: '100%', position: 'relative' }}>
                                    <img src={AlarmChannelImage} width="100%" />
                                    <div style={{ position: 'absolute', top: "60%", left: '45%', zIndex: 10000 }}>
                                        <div style={{ ...overlayBoxStyle }}>
                                            <p><FormattedMessage id="Set the Channel for the alarm, this will only show the relevant channels based on the alarm type. Some alarm are on the device and will not give you the option to set per channel." /></p>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    }
                    {currentPage === 2 &&
                        (tempAlarm.type !== 'consumption' ?
                        <div style={{ display: 'flex', width: '100%' }}>
                            <div style={{ width: '50%', margin: '0 10px' }}>
                                <h4><b><FormattedMessage id="Step 1" /></b></h4>
                                <div style={{ width: '100%', position: 'relative' }}>
                                    <img src={AlarmSetInput} width="100%" />
                                    <div style={{ position: 'absolute', top: '60%', left: '45%', zIndex: 10000 }}>
                                        <div style={{ ...overlayBoxStyle }}>
                                            <p><FormattedMessage id="From here you set how this alarm will be triggered. This includes the condition, value and unit to measure from." /></p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div style={{ width: '50%', margin: '0 10px' }}>
                                <h4><b><FormattedMessage id="Step 2" /></b></h4>
                                <div style={{ width: '100%', position: 'relative' }}>
                                    <img src={AlarmClrInput} width="100%" />
                                    <div style={{ position: 'absolute', top: '60%', left: '45%', zIndex: 10000 }}>
                                        <div style={{ ...overlayBoxStyle }}>
                                            <p><FormattedMessage id="From here you set how this alarm will be cleared. This is the condition for when the alarm will be cleared." /></p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div> 
                        :
                        <div style={{ display: 'flex', width: '100%' }}>
                            <div style={{ width: '50%', margin: '0 10px' }}>
                                <h4><b><FormattedMessage id="Step 1" /></b></h4>
                                <div style={{ width: '100%', position: 'relative' }}>
                                    <img src={AlarmConsumptionSet} width="100%" />
                                    <div style={{ position: 'absolute', top: '60%', left: '45%', zIndex: 10000 }}>
                                        <div style={{ ...overlayBoxStyle }}>
                                            <p><FormattedMessage id="From here you set how this consumption alarm will be triggered. This includes the condition, value and unit to measure from." /></p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div style={{ width: '50%', margin: '0 10px' }}>
                                <h4><b><FormattedMessage id="Step 2" /></b></h4>
                                <div style={{ width: '100%', position: 'relative' }}>
                                    <img src={AlarmConsumptionDate} width="100%" />
                                    <div style={{ position: 'absolute', top: '60%', left: '45%', zIndex: 10000 }}>
                                        <div style={{ ...overlayBoxStyle }}>
                                            <p><FormattedMessage id="From here you set the time frame for the period where the consumption will be calculated." /></p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                   )}
                    {currentPage === 3 &&
                        <div style={{display: 'flex', justifyContent: 'center'} }>
                            <div style={{ width: '50%', margin: '0 10px' }}>
                                <h4><b><FormattedMessage id="Step 1" /></b></h4>
                                <div style={{ width: '100%', position: 'relative' }}>
                                    <img src={AlarmCount} width="100%" />
                                    <div style={{ position: 'absolute', top: '60%', left: '45%', zIndex: 10000 }}>
                                        <div style={{ ...overlayBoxStyle }}>
                                            <p><FormattedMessage id="In this section of the alarm setup you set the counts for both the alarm trigger and clear. These counts are the number of consecutive readings that the set/clear values must be met before the alarm is sent to recipients." /></p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    }
                    {currentPage === 4 &&
                        <div>
                            <div style={{ display: 'flex', width: '100%' }}>
                                <div style={{ width: '50%', margin: '0 10px' }}>
                                    <h4><b><FormattedMessage id="Step 1" /></b></h4>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <img src={AlarmMessage} width="100%" />
                                        <div style={{ position: 'absolute', top: '50%', left: '35%', zIndex: 10000 }}>
                                            <div style={{ ...overlayBoxStyle }}>
                                                <p><FormattedMessage id="Set The Alarm Name / Message - This is the message that will appear in the notification that any recipients will receive." /></p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div style={{ width: '50%', margin: '0 10px' }}>
                                    <h4><b><FormattedMessage id="Step 2" /></b></h4>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <img src={AlarmMessage} width="100%" />
                                        <div style={{ position: 'absolute', top: "50%", left: '45%', zIndex: 10000 }}>
                                            <div style={{ ...overlayBoxStyle }}>
                                                <p><FormattedMessage id="Set the max alarms that a recipient will receive in a 24 hour period. For example if an alarm triggers and clear 4 times in 24 hours you would only receive notifications 3 times." /></p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', width: '100%' }}>
                                <div style={{ width: '50%', margin: '0 10px' }}>
                                    <h4><b><FormattedMessage id="Step 3" /></b></h4>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <img src={AlarmTimeframe} width="100%" />
                                        <div style={{ position: 'absolute', top: '65%', left: '35%', zIndex: 10000 }}>
                                            <div style={{ ...overlayBoxStyle }}>
                                                <p><FormattedMessage id="Here you can optionally set the timeframe for when an alarm will be triggered. This feature may be helpful for companies that have seperate night / day teams" /></p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div style={{ width: '50%', margin: '0 10px' }}>
                                    <h4><b><FormattedMessage id="Step 4" /></b></h4>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <img src={AlarmDateRange} width="100%" />
                                        <div style={{ position: 'absolute', top: "5%", left: '45%', zIndex: 10000 }}>
                                            <div style={{ ...overlayBoxStyle }}>
                                                <p><FormattedMessage id="Here you can optionally set the date range for when an alarm will be triggered. This feature may be helpful for companies that have seperate summer / winter priorities" /></p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                }

            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={(): void => toggleHelpModal()}
                    variant="contained"
                    color="error"
                >
                    <FormattedMessage id="Close" />
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default AlarmHelpModal